import moment from 'moment';
import { FrameworkKey } from '../../../../utils/enums';

export const isAuditPlanRequired = (formData) =>
  formData.framework_key === FrameworkKey.ISO_IEC_27001_2022;

export const validateAuditForm = (formData, calculateEndDate) => {
  const newErrors = {};

  if (!formData.audit_name?.trim()) {
    newErrors.audit_name = "Audit name is required";
  }

 
  if (!formData.framework_base && !formData.framework_id && !formData.soc2_standard_id) {
    newErrors.framework_base = "Framework is required";
  }

  // Auditor required for all audit types
  if (!formData.auditors || formData.auditors.length === 0) {
    newErrors.auditors = "At least one auditor is required";
  }

  // External audits can only have external auditors
  if (formData.audit_type === "external" && formData.auditors?.some((a) => a.is_internal)) {
    newErrors.auditors = "External audits can only have external auditors assigned";
  }

  // Validate type selection for SOC2
  if (formData.framework_base === FrameworkKey.SOC2) {
    if (!formData.framework_type) {
      newErrors.framework_type = "Type is required";
    }
  } else {
    // Validate framework_id for non-SOC2 frameworks (HIPAA, PCI-DSS, etc.)
    if (!formData.framework_id) {
      newErrors.framework_id = "Framework selection error";
    }
  }

  if (!formData.audit_type) {
    newErrors.audit_type = "Audit type is required";
  }

  if (!formData.framework_key) {
    newErrors.framework_id = "Framework key is required";
  }

  if (
    isAuditPlanRequired(formData) &&
    (!formData.audit_plan_files || formData.audit_plan_files.length === 0)
  ) {
    newErrors.audit_plan_files =
      "Audit plan document is required for ISO 27001 audits";
  }

  const isPointInTime =
    (formData.framework_base === "SOC2" && formData.framework_type === "type1") ||
    formData.maximum_window_months === 1;

  // Date validation
  if (!formData.audit_start_date) {
    if (isPointInTime) {
      newErrors.audit_start_date = "Audit date is required";
    } else {
      newErrors.audit_start_date = "Audit start date is required";
    }
  }

  if (!isPointInTime) {
    // Validate audit period for Type 2 and HIPAA audits
    if (formData.audit_window_months === "custom" && !formData.custom_end_date) {
      newErrors.custom_end_date = "Custom end date is required";
    }

    const endDate = calculateEndDate();
    if (formData.audit_start_date && endDate) {
      const startDate = moment(formData.audit_start_date);
      const end = moment(endDate);

      if (end.isSameOrBefore(startDate)) {
        newErrors.custom_end_date = "End date must be after start date";
      }

      // Validate against minimum and maximum window sizes
      const periodInMonths = end.diff(startDate, 'months', true);

      if (formData.minimum_window_months && periodInMonths < formData.minimum_window_months) {
        newErrors.custom_end_date = `Audit period must be at least ${formData.minimum_window_months} month(s). Selected period is ${Math.round(periodInMonths)} month(s).`;
      }

      if (formData.maximum_window_months && periodInMonths > formData.maximum_window_months) {
        newErrors.custom_end_date = `Audit period cannot exceed ${formData.maximum_window_months} month(s). Selected period is ${Math.round(periodInMonths)} month(s).`;
      }
    }
  }

  return newErrors;
};

export const initialFormState = {
  audit_name: "",
  framework_base: "", // SOC2 or HIPAA
  framework_type: "", // type1 or type2 (for SOC2 only)
  framework_id: "", // For HIPAA or final selection
  soc2_standard_id: null, // For storing selected SOC 2 standard framework_id
  auditors: [], // Array of { id, name, email, is_internal }
  audit_type: "",
  audit_window_months: "12",
  audit_start_date: "",
  custom_end_date: "",
  minimum_window_months: null,
  maximum_window_months: null,
  framework_key: null,
  audit_plan_files: [], // Array of File objects selected by the user (uploaded on submit)
};
